import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=3435b36a&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=3435b36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3435b36a",
  null
  
)

export default component.exports